import request from "@/shared/apis";

const invigilation = {
  forItem: (itemId) => request.get(`timetable-items/${itemId}/invigilation`),
  suggest: (sittingVenueId) => request.post(`sitting-venues/${sittingVenueId}/invigilators/suggest`),
  assign: (sittingVenueId, dto) => request.post(`sitting-venues/${sittingVenueId}/invigilators`, dto),
  remove: (invigilationId) => request.delete(`invigilations/${invigilationId}`),
};

export default invigilation;
